module.exports = __webpack_public_path__ + "static/media/IDYLE-HILLS-ESTATES-CIVIC-ASSOCIATION-BY-LAWS-June2016.0c18606c.pdf";